export const useMemberNotesKey = {
  base: ["notes"] as const,
  summary: (patientId: string) => [...useMemberNotesKey.base, patientId, "summary"] as const,
};
